import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Container = styled(Stack)`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.freeBadge};
  right: 48px;
  bottom: 32px;
  background-color: ${theme.colors.skyblue_600};
  border-radius: 8px;
  opacity: 0;
  transition: all ease-in-out 150ms;

  visibility: hidden;

  &:hover {
    cursor: pointer;
  }

  &.is-visible {
    opacity: 0.8;
    visibility: visible;

    &:hover {
      opacity: 1;
    }
  }
`;
